import {IApplicationState, ILayerState} from "../types";
import {Reducer} from "redux";

const deleteLayer: Reducer<IApplicationState['map']> = (state, action) => {
    const {type} = action.payload;
    let mapStyle = state?.mapStyle;
    const layerState: ILayerState = {...state?.layerState};
    const layerNamesByType = {...state?.layerNamesByType};
    const databaseLayerIds = {...state?.databaseLayerIds};
    let layerIds = state?.layerIds;
    delete layerState[type];
    delete layerNamesByType[type];
    delete databaseLayerIds[type];
    // fake filter
    layerIds = layerIds?.filter(layerType => layerType !== type);
    const layers = mapStyle?.get('layers').filter((layer: ILayerState) => layer.id !== type);
    const sources = mapStyle?.get('sources').delete(type);
    mapStyle = mapStyle?.set('layers', layers).set('sources', sources);
    return {...state, mapStyle, layerIds, databaseLayerIds, layerNamesByType, layerState} as IApplicationState['map'];
}

export { deleteLayer };
